import { AnalyticsClickEvents } from "../../../../types/analytics";

export const title = "Apply Now And Pay No Establishment Fee";
export const cta: AnalyticsClickEvents = "Get a rate estimate";
export const disclaimer =
  "Finance provided by Wisr Finance Pty Ltd ACN 119 503 221 Australian Credit Licence 458572 to approved applicants. Terms and conditions apply. This does not constitute an offer for credit nor does it guarantee that an offer for any product will be made to you. ";
